const weightMetrics = [
    {
        "ID": 1,
        "name": "kg"
    }, {
        "ID": 2,
        "name": "lb"
    }, {
        "ID": 3,
        "name": "oz"
    }
]
export default weightMetrics;